import { UAParser } from 'ua-parser-js';

const { getBrowser, getEngine, getOS } = new UAParser();

const [
  { name: osName, version: osVersion },
  { name: engineName, version: engineVersion },
  { name: browserName, version: browserVersion },
] = await Promise.all([
  getOS().withClientHints(),
  getEngine().withClientHints(),
  getBrowser().withClientHints(),
]);

export const supportsBarcodeDetector =
  typeof window !== 'undefined' &&
  'BarcodeDetector' in window &&
  /**
   * Chromium browsers prior to version 113 on macOS Ventura (13.0) and up failed to access Apple
   * Neural Engine for BarcodeDetector, causing BarcodeDetector to silently fail.
   * Read more: https://issues.chromium.org/issues/40245611
   */
  !(
    osName === 'macOS' &&
    osVersion &&
    Number.parseInt(osVersion, 10) >= 13 &&
    engineName === 'Blink' &&
    engineVersion &&
    Number.parseInt(engineVersion, 10) < 113
  ) &&
  /**
   * All browsers on Android 10 and below failed with "Failed to execute 'detect' on
   * BarcodeDetector: Barcode detection service unavailable." error.
   */
  !(osName === 'Android' && osVersion && Number.parseInt(osVersion, 10) <= 10);

export const supportsStyleChangeOnHover =
  browserName !== 'Mobile Safari' || (browserVersion && Number.parseInt(browserVersion, 10) >= 13);

export const supportsThemeColor = browserName !== 'Mobile Safari';
